/**
 * @generated SignedSource<<8c904947f965e7671de274f54b7ef02e>>
 * @relayHash c129616ebc682e824d3bf3b37f2e3d91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c00b9b16fa88ad4906ee150e8b79e09ed8f9b75a4441ea5f608e420ef4295c2b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionBacklogPanelRelayQuery } from './uiVersionBacklogPanelRelayQuery.graphql';

import isVisualRefreshEAPEnabled_provider from '@atlassian/jira-relay-provider/src/visual-refresh-eap-2.relayprovider';

const node: PreloadableConcreteRequest<uiVersionBacklogPanelRelayQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c00b9b16fa88ad4906ee150e8b79e09ed8f9b75a4441ea5f608e420ef4295c2b",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProjects"
          ]
        }
      ]
    },
    "name": "uiVersionBacklogPanelRelayQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": isVisualRefreshEAPEnabled_provider
    }
  }
};

export default node;
